import { OrderStage } from "@/pages/billing/types";
import type { OrderPayment, PaymentType } from "../[orderId]/payment/[paymentId]/types";

type UncollectibleOrderLike = {
  status?: OrderPayment["status"];
  order?: { status?: OrderPayment["order"]["status"] } | null;
};

export function isUncollectibleOrderPayment(orderPayment: UncollectibleOrderLike): boolean {
  return orderPayment.status === OrderStage.UNCOLLECTIBLE || orderPayment.order?.status === OrderStage.UNCOLLECTIBLE;
}

export function isUncollectibleRefundContext(payment: PaymentType, order?: UncollectibleOrderLike | null): boolean {
  if (order) {
    return isUncollectibleOrderPayment(order);
  }

  return payment.orderPayments.some(isUncollectibleOrderPayment);
}
